import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { AlertType } from '@/helpers/entities/enums/AlertType';
let AlertMixin = class AlertMixin extends Vue {
    toggleAlert(message, alertType) {
        this.$store.commit('toggleAlert');
        this.$store.commit('setAlertType', alertType);
        this.$store.commit('populateAlertMessage', message);
    }
    successNotification(message) {
        this.$store.commit('toggleAlert');
        this.$store.commit('setAlertType', AlertType.success);
        this.$store.commit('populateAlertMessage', message);
    }
    errorNotification(message) {
        this.$store.commit('toggleAlert');
        this.$store.commit('setAlertType', AlertType.error);
        this.$store.commit('populateAlertMessage', message.replace('GraphQL error: ', ''));
    }
    clearPersistentErrorNotification() {
        setTimeout(() => {
            this.$store.commit('toggleAlert', false);
            this.$store.commit('clearAlertMessage');
        }, 3000);
    }
};
AlertMixin = __decorate([
    Component
], AlertMixin);
export default AlertMixin;
